<template>
  <div :class="{'zh-style': language === 'zh'}">

    <div id="commission-banner">
      <h2>{{ $t('affiliate') }}</h2>
      <div class="content-box" id="refer-friends">
        <div class="content">
          <p class="little-title">{{ $t('inviteFriends') }}</p>
          <p class="main-num">{{ commissionInfo.inviteNum }}</p>
          <p class="unit">{{ commissionInfo.inviteNum <= 1 ? $tc('referrals', 1) : $tc('referrals', 2) }}</p>
          <p class="explain">{{ $t('friendsNumExplain') }}</p>
        </div>
      </div>

      <div class="content-box" id="rewards">
        <div class="content">
          <p class="little-title">{{ $t('totallyRewards') }}</p>
          <p class="main-num"><span>{{ $t(currentSymbol) }}</span>{{ parseFloat(commissionInfo.total).toFixed(2) }}</p>
          <p class="explain">{{ $t('commissionExplain') }}<br>
            <router-link to="/affiliate-program?anchorId=become-affiliate" class="rewards-details">{{$t('rewardsRules')}}</router-link>
          </p>
        </div>
      </div>

      <div class="content-box" id="withdrawal">
        <div class="content">
          <p class="little-title">{{ $t('withdrawAmount') }}</p>
          <p class="main-num"><span>{{ $t(currentSymbol) }}</span>{{ parseFloat(commissionInfo.balance).toFixed(2) }}</p>
          <p class="explain">{{ $t('withdrawNumExplain') }}<br>
            <router-link to="commission/withdraw-details" class="withdraw-details">{{ $t('withdrawDetails') }}</router-link>
          </p>
          <button class="withdraw-btn" data-toggle="modal" data-target="#with-draw-modal">{{ $t('withdraw') }}</button>
        </div>
      </div>

      <div class="content-box" id="invite-code-component">
        <invite-friend class="content " :invitation-code="commissionInfo.inviteCode"></invite-friend>
      </div>

    </div>

    <invite-record :show-commission=true class="invite-record-component"></invite-record>
    <withdraw></withdraw>
  </div>
</template>

<script>
  import InviteRecord from '../../components/commission/inviteRecord/InviteRecord.vue'
  import InviteFriend from '../../components/commission/inviteFriend/InviteFriend.vue'
  import Withdraw from '../../components/withdraw/Index.vue'
  import locales from './lang'
  import { mapState } from 'vuex'

  export default {
    name: 'commission',
    components: {InviteRecord, InviteFriend, Withdraw},
    locales,
    computed: {
      ...mapState({
        commissionInfo: state => state.commission.commissionInfo,
        language: state => state.currentLang,
        currentSymbol: state => state.currentSymbol
      })
    },
    mounted() {
      this.$store.dispatch('getCommissionInfo')
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  #commission-banner {
    width: 100%;
  }

  h2 {
    display: none;
    @media screen and (max-width: 767px) {
      display: block;
      font-size: .24rem;
      line-height: 32px;
      color: #111111;
      font-weight: 600;
      text-align: center;
      margin-bottom: 0.24rem;
    }
  }

  .content-box {
    display: inline-block;
    float: left;
    padding-right: 24px;
  }
  .content {
    border: 1px solid #E0D7E3;
    border-radius: .08rem;
    text-align: center;
    height: 330px;
    margin-bottom: 24px;
  }

  .little-title {
    font-size: .16rem;
    padding: 0 .16rem;
    line-height: .48rem;
    height: .48rem;
    border-bottom: 1px solid #E0D7E3;
    margin-bottom: .24rem;
    color: #111;
    letter-spacing: 0;
    text-align: left;
  }
  .main-num {
    letter-spacing: 0;
    font-size: .58rem;
    color: #111;
    line-height: .58rem;
    height: .58rem;
    font-weight: 500;
    span {
      font-size: 14px;
      letter-spacing: 0;
    }
  }

  .explain {
    font-size: 14px;
    color: #666;
    letter-spacing: 0;
    line-height: .20rem;
    padding: 0 .16rem;
  }

  #refer-friends {
    width: 244px;
    .unit {
      font-size: 12px;
      color: #666;
      letter-spacing: 0;
      margin-bottom: .24rem;
      line-height: .18rem;
    }
    .main-num {
      margin-bottom: 0.08rem;
    }
  }
  #rewards {
    width: 280px;
    .main-num {
      margin-bottom: .5rem;
    }
    .little-title {
      position: relative;
    }
    .rewards-details {
      font-size: 14px;
      color: #416CF8;
      line-height: 20px;
      letter-spacing: 0;
      cursor: pointer;
    }
  }
  #withdrawal {
    width: 280px;
    .main-num {
      margin-bottom: .5rem;
    }
    .explain {
      margin-bottom: .24rem;
    }
    .little-title {
      position: relative;
    }
    .withdraw-details {
      font-size: 14px;
      color: #416CF8;
      line-height: 20px;
      letter-spacing: 0;
      cursor: pointer;
    }
    button.withdraw-btn {
      width: 110px;
      height: 28px;
      background: #F76B4C;
      border-radius: 14px;
      line-height: 28px;
      font-size: 12px;
      color: #FFFFFF;
      font-weight: 500;
      text-align: center;
      border: none;
    }
  }
  #invite-code-component {
    width: calc(100% - 244px - 280px - 280px);
    padding-right: 0;
  }

  @mixin phoneStyle() {
    #refer-friends, #rewards, #withdrawal, #invite-code-component {
      width: 100%;
      padding-right: 0;
    }
    .content {
      height: auto;
      border-radius: .05rem;
      padding-bottom: .24rem;
      .little-title {
        font-size: 14px;
        line-height: .44rem;
        height: 0.44rem;
        margin-bottom: .2rem;
      }
      .main-num {
        font-size: 48px;
        line-height: 48px;
        height: 48px;
      }
    }
    #refer-friends {
      .main-num {
        margin-bottom: 0;
      }
      .unit {
        margin-bottom: .16rem;
      }
    }
    #rewards {
      position: relative;
      .main-num {
        margin-bottom: .16rem;
      }
      .rewards-details {
        position: absolute;
        top: 10px;
        right: 0.16rem;
        width: 99px;
        height: 24px;
        line-height: 22px;
        border: 1px solid #416CF8;
        border-radius: 4px;
        font-size: 14px;
        color: #416CF8;
        cursor: pointer;
        text-align: center;
      }
    }
    #withdrawal {
      position: relative;
      .main-num {
        margin-bottom: .16rem;
      }
      .withdraw-details {
        position: absolute;
        top: 10px;
        right: 0.16rem;
        width: 121px;
        height: 24px;
        line-height: 22px;
        border: 1px solid #416CF8;
        border-radius: 4px;
        font-size: 14px;
        color: #416CF8;
        cursor: pointer;
        text-align: center;
      }
    }
  }

  @mixin padStyle() {
    #refer-friends, #rewards, #withdrawal, #invite-code-component {
      width: 50%;
    }
    #rewards {
      padding-right: 0;
    }
  }


  @media (max-width: 1310px) {
    @include padStyle();
  }
  @media (max-width: 767px) {
    @include phoneStyle();
  }

  .invite-record-component {
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?0b315499